// extracted by mini-css-extract-plugin
module.exports = {"label":"OpenLabel-module--label--zk-6n"};